




































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'

@Component
export default class SidebarLayout extends Vue {
  private serverVersion: string = ''

  @Prop()
  private title!: string

  @Prop({ default: 'simple-header' })
  private header!: string

  @Prop({ default: true })
  private showHeader!: boolean

  private showSideMenu = false
  private showShadow = false

  @Watch('$route', { immediate: true, deep: true })
  private async onUrlChangeAsync(newVal: any) {
    this.showSideMenu = this.$vuetify.breakpoint.lgAndUp
  }

  private toggleSideMenu() {
    this.showSideMenu = !this.showSideMenu
    this.$bus.$emit('sidemenu:toggle')
  }

  private onScroll(e: any) {
    this.showShadow = e.target.scrollTop > 10;
  }
}
